import { BooleanInput } from '@angular/cdk/coercion';
import { NgClass, NgIf } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterLink } from '@angular/router';
import { BACKEND_URLS, BackendUrls } from 'app/app.config';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { Subject, concatMap, takeUntil } from 'rxjs';

@Component({
    selector       : 'user-spezia',
    templateUrl    : './user.component.html',
    styles:[
        `.white-icon{
            color: white
        }`
    ],
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'user',
    standalone     : true,
    imports        : [MatButtonModule, MatMenuModule, NgIf, MatIconModule, MatDividerModule, RouterLink],
})
export class UserComponent implements OnInit, OnDestroy
{
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: User;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private _httpClient: HttpClient,
        @Inject(BACKEND_URLS) private backendUrls: BackendUrls,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) =>
            {
                this.user = user;
                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void
    {

        // Return if user is not available
        if ( !this.user )
        {
            return;
        }

        // Update the user
        this._userService.update({
            ...this.user,
            status,
        }).subscribe();
    }

    /**
     * Sign out
     */
    signOut(): void
    {

        ////cablatone come su sanlazzaro- DA VEDERE!!!!
        if(this.user?.usermode=='spid'){


            this._httpClient.post(`${this.backendUrls.backendApiUrl}/login/sign_out`,{}).subscribe(
               ()=>{
                const url = 'https://pratiche.comune.laspezia.it/SP/LogoutSAML';
                const fd = new FormData();
                fd.append('idCliente', '011015');
                fd.append('urlRed', 'https://istanze.comune.laspezia.it/index.html');
                this._httpClient.post(url, fd,
                    {
                        headers: new HttpHeaders(),
                        withCredentials:true
                    }).subscribe(
                        ()=> window.location.href = 'https://istanze.comune.laspezia.it'
                    )

               }


            )

            this._router.navigate(['/sign-out']);
        }
        else{
            this._router.navigate(['/sign-out']);
        }

        this._changeDetectorRef.markForCheck();

    }

    vai(){
        window.location.href="https://www.comune.laspezia.it/td/sso?next=https://www.comune.laspezia.it/prenotazione-appuntamenti-personali"
    }
}
